import * as z from "zod";

export const updateBillingSettings = {
  name: "updateBillingSettings" as const,
  input: z.object({
    teamId: z.string(),
    billingAutomation: z.enum(["auto", "manual"]),
    manualBillingDueInDays: z.number().int().min(1).max(365),
    billingFailureMode: z.enum(["allow", "restrict"]),
    /**
     * Engine billing anchor. Drives CRDB
     * `account_billing_settings.billing_day_of_month` and every per-product
     * `targetBillingDay` Mongo subdoc (via fan-out). When unified billing is
     * enabled, this is also the day the unified close cycle fires.
     *
     * Legacy day/schedule fields (`schedule`, `billingDayOfMonth`,
     * `firstBillingDayOfMonth`, `dayOfWeek`) are written separately to
     * Mongo via `putTeam` — they're independent of this RPC.
     */
    targetBillingDay: z.number().int().min(1).max(28),
  }),
  output: z.object({ success: z.boolean() }),
};
